import { FormattedMessage, FormattedNumber } from "react-intl";
import { ActivityIndicator } from "react-native";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import { useEventOccurrence } from "views/EventDetails/hooks";
import { Card, Flex } from "components/styles";
import useOrderSession from "hooks/useOrderSession";
import OrderSessionButton from "components/atoms/OrderSessionButton";
import environment from "setup/environment";
import EventHeading from "views/EventDetails/partials/EventHeading";

import * as Styled from "./styles";
import { useCheckout } from "./hooks";

const Checkout: React.FC = () => {
  const { eventOccurrence, loading } = useEventOccurrence(true);
  const { expireAt, expireIn, isExpired, onReset } = useOrderSession();
  const {
    lines,
    total,
    error,
    loading: checkoutLoading,
    payWithCash,
    payWithTerminal,
    payWithPos,
    checkoutWithoutPayment,
  } = useCheckout();

  if (loading) {
    return <ActivityIndicator />;
  }

  if (!eventOccurrence) {
    return (
      <Text textAlign="center" margin="2rem">
        <FormattedMessage defaultMessage="Event not found" />
      </Text>
    );
  }

  return (
    <Flex padding="0.5rem" flexDirection="column" height="100%" overflow="auto">
      <EventHeading {...eventOccurrence} />
      <Card>
        <Styled.Heading>
          <FormattedMessage defaultMessage="Checkout Summary" />
        </Styled.Heading>
        {lines.map(({ name, quantity }) => (
          <Styled.Subheading key={name}>
            {quantity} {name}
          </Styled.Subheading>
        ))}
        {total > 0 && (
          <>
            <Styled.Total>
              <FormattedNumber
                style="currency"
                currency={environment.CURRENCY}
                value={total}
              />
            </Styled.Total>
            <Styled.Subheading>
              <FormattedMessage defaultMessage="Payment Type" />
            </Styled.Subheading>
          </>
        )}
        <Styled.Actions>
          {total === 0 ? (
            <Button
              $fullW
              type="button"
              $mode="tertiary"
              size="large"
              disabled={isExpired || checkoutLoading}
              onClick={checkoutWithoutPayment}
            >
              <FormattedMessage defaultMessage="CONFIRM" />
            </Button>
          ) : (
            <>
              <Button
                $fullW
                type="button"
                $mode="tertiary"
                size="large"
                disabled={isExpired || checkoutLoading}
                onClick={payWithCash}
              >
                <FormattedMessage defaultMessage="CASH" />
              </Button>
              <Button
                $fullW
                type="button"
                $mode="tertiary"
                size="large"
                disabled={isExpired || checkoutLoading}
                onClick={payWithTerminal}
              >
                <FormattedMessage defaultMessage="CARD (STRIPE)" />
              </Button>
              <Button
                $fullW
                type="button"
                $mode="tertiary"
                size="large"
                disabled={isExpired || checkoutLoading}
                onClick={payWithPos}
              >
                <FormattedMessage defaultMessage="POS" />
              </Button>
            </>
          )}
          {expireAt && (
            <OrderSessionButton
              {...{
                expireIn,
                isExpired,
                onReset,
              }}
            />
          )}
          {error && <Styled.Error>{error}</Styled.Error>}
        </Styled.Actions>
      </Card>
    </Flex>
  );
};

export default Checkout;
